import { ArrowRight, Heart, Sparkles } from 'lucide-react';

export const highlights = [
    {
        title: 'Tailored comfort',
        description:
            'Choose from boutique suites curated for slow mornings, smart workspaces, and intimate evenings.',
        icon: Sparkles,
    },
    {
        title: 'Effortless bookings',
        description:
            'Instant availability, transparent pricing, and personalized stay preferences saved to your profile.',
        icon: ArrowRight,
    },
    {
        title: 'Thoughtful hospitality',
        description:
            'Concierge texting, curated local escapes, and late-night cravings delivered right to your door.',
        icon: Heart,
    },
];

export const stayMoments = [
    {
        label: 'Sunrise suites',
        detail: 'Floor-to-ceiling windows, plush bedding, and pour-over coffee awaiting your wake up call.',
    },
    {
        label: 'Work/play balance',
        detail: 'Private desk pods, lightning-fast Wi-Fi, and lounge breaks with crafted refreshments.',
    },
    {
        label: 'Nightfall unwind',
        detail: 'Rainfall showers, ambient playlists, and starlit courtyard lounges minutes from your room.',
    },
];

export const testimonials = [
    {
        name: 'Olivia Chen',
        stay: 'Five-night creative retreat',
        quote: '“Every detail felt intentional. The team remembered my coffee order and curated the perfect workspace.”',
    },
    {
        name: 'Marcus Reed',
        stay: 'Weekend reset',
        quote: '“Elegant, calm, and beautifully modern. The courtyard evenings were the highlight of our getaway.”',
    },
];
